import type { TreeSpecies } from '../../../api/tree-species';
import { SimpleModal } from '../../shared/SimpleModal';

interface Props {
  species: TreeSpecies;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DeleteTreeSpeciesModal({ species, busy, onCancel, onConfirm }: Props) {
  return (
    <SimpleModal
      open
      onClose={onCancel}
      title="Delete tree species?"
      width={420}
      footer={
        <div className="flex justify-end gap-2">
          <button type="button" className="nb-btn nb-btn-ghost" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="nb-btn nb-btn-primary"
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      }
    >
      <p className="m-0 text-sm text-stone-700 dark:text-stone-300">
        <strong>{species.name}</strong> will be removed for good. To hide it from pickers but keep
        it on record, deactivate it instead.
      </p>
    </SimpleModal>
  );
}
